module.exports = __webpack_public_path__ + "static/media/3.c1d0c35f.svg";